<template>
	<div class="tab-mobile">
		<div class="wrapper-tab-mobile">
			<div 
				v-for="item in data" 
				:key="item.id">
				<div 
					@click="$emit('select', item)"
					:class="{'active': item.active}"
					class="btn-tab">
					<span 
						v-if="!item.active"
						:style="`color:${globalColors.primary}`"
						class="btn-arrow">+</span>
					<span 
						v-if="item.active"
						:style="`color:${globalColors.primary}`"
						class="btn-arrow">-</span>
					<p>{{item.name}}</p>
				</div>
				<div 
					v-if="item.active"
					class="wrapper-tab-content">
					<div v-if="item.flag === 'questions'">
						<form-questions />
						<wrapper-answer :data="question" v-for="question in listQuestions" :key="question.id"/>
					</div>
					<div v-if="item.flag === 'opinions'">
						<wrapper-opinions :opinions="opinions"/>
					</div>
					<div v-if="item.flag === 'service'">
						<content-text
							:content="subSection"
							v-for="subSection in select.subSections"
							:key="subSection.id"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import formQuestions from '@/components/detail/formQuestions';
import wrapperAnswer from '@/components/detail/wrapperAnswer';
import wrapperOpinions from '@/components/detail/wrapperOpinions';
import contentText from '@/components/detail/content';

export default {
	name: 'tab-mobile',
	props: {
		data: {
			default: () => [],
			type: [Array, Object],
		},
		opinions: {
			default: () => [],
			type: Array,
		},
		select: {
			default: () => {},
			type: Object,
		},
		listQuestions: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		formQuestions,
		wrapperAnswer,
		wrapperOpinions,
		contentText,
	},
};
</script>
<style lang="scss" scoped>
	.tab-mobile {
		margin-bottom: 5.5rem;
		padding: 0 5%;
	}

	.wrapper-tab-mobile {
		border: 0.1rem solid color(border-grey-medium);
	}

	.btn-tab {
		align-items: center;
		border: 0.1rem solid color(border-grey-medium);
		border-left: none;
		border-right: none;
		display: flex;
		font-family: font(open-semibold);
		font-size: size(medium);
		width: 100%;

		&.active {
			border: none;
		}
	}

	.btn-arrow {
		cursor: pointer;
		font-family: font(open-bold);
		font-size: size(maxsmall);
		margin: 0 2.2rem 0 0.9rem;
	}

	.wrapper-tab-content {
		padding: 0.9rem;
	}
</style>





// WEBPACK FOOTER //
// tabProductMobile.vue?c109b5b4